var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3281 48C56.6881 43.5467 58.6615 38 58.6615 32C58.6615 26 56.6881 20.4533 53.3281 16M10.6615 16C7.30146 20.4533 5.32812 26 5.32812 32C5.32812 38 7.30146 43.5467 10.6615 48M44.7948 41.6C46.7948 38.9333 47.9948 35.6 47.9948 32C47.9948 28.4 46.7948 25.0667 44.7948 22.4M19.1948 22.4C17.1948 25.0667 15.9948 28.4 15.9948 32C15.9948 35.6 17.1948 38.9333 19.1948 41.6M31.9948 37.3333C33.4093 37.3333 34.7658 36.7714 35.766 35.7712C36.7662 34.771 37.3281 33.4145 37.3281 32C37.3281 30.5855 36.7662 29.229 35.766 28.2288C34.7658 27.2286 33.4093 26.6667 31.9948 26.6667C30.5803 26.6667 29.2237 27.2286 28.2236 28.2288C27.2234 29.229 26.6615 30.5855 26.6615 32C26.6615 33.4145 27.2234 34.771 28.2236 35.7712C29.2237 36.7714 30.5803 37.3333 31.9948 37.3333Z",
    stroke: "#00D1FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.bd4774dbdcf556fa40ed0b5dd2955968.svg";
export { ForwardRef as ReactComponent };